// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/" + ({"385":"router","836":"hanzi-writer","905":"videos","981":"raven"}[chunkId] || chunkId) + "-legacy." + {"385":"7579a526","549":"e259b11a","586":"891cc521","663":"6a01eced","733":"225b0dd8","836":"4d55adde","905":"4d982581","981":"975ae4f8"}[chunkId] + ".js";
};